/**
 * Productpagina — sidebar (product-cart-item). Na wijziging: npm run build:product-page
 */

export const productCartItemLabels = {
  sidebarTitle: 'Huur direct dit product',
  fromLabel: 'Vanaf',
  perDaySuffix: 'per dag',
  rentalPeriod: 'Huurperiode',
  pickupLocation: 'Ophaallocatie',
  dateFromPlaceholder: 'Selecteer datum',
  dateToPlaceholder: 'Selecteer einddatum',
  /** getoond bij availabilityMode 'on_reserve' (geen live planning-koppeling) */
  availabilityOnReserve: 'Beschikbaarheid controleert u bij reserveren',
  /** alleen gebruiken als availabilityMode 'guaranteed' én echte voorraadkoppeling actief is */
  availabilityGuaranteed: 'Direct beschikbaar',
  reserve: 'Reserveer direct',
  reviewsTemplate: '({count} reviews)',
  badgePopular: 'Veel gekozen'
};

/**
 * Beschikbaarheidsregel in de sidebar:
 * - on_reserve  → eerlijk, past bij huidige site (aanbevolen)
 * - guaranteed  → alleen als planning/voorraad live gekoppeld is
 * - hidden      → regel niet tonen
 */
/** Labels voor prijsregels in de sidebar (PHP-key → weergave) */
export const productCartItemPriceLabels = {
  per_uur: 'Per uur',
  per_halve_dag: 'Per halve dag',
  per_weekend: { label: 'Weekend', detail: 'za 08:00 t/m ma 08:00' },
  price2: 'Per week',
  per_4_weken: 'Per 4 weken',
  per_stuk: 'Per stuk',
  per_4_stuk: 'Per 4 stuk',
  per_set: 'Per set',
  per_meter: 'Per meter',
  per_bundel: 'Per bundel'
};

export function normalizeProductPriceTierKey(label) {
  const l = String(label || '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/:$/, '');

  if (!l) return '';
  if (l.includes('halve dag')) return 'per_halve_dag';
  if (/\buur\b/.test(l)) return 'per_uur';
  if (l.includes('weekend')) return 'per_weekend';
  if (/4\s*(wk|weken)/.test(l)) return 'per_4_weken';
  if (/\bweek\b/.test(l)) return 'price2';
  if (/\bdag\b/.test(l)) return 'price';
  if (l.includes('stuk') && l.includes('4')) return 'per_4_stuk';
  if (l.includes('stuk')) return 'per_stuk';
  if (l.includes('set')) return 'per_set';
  if (l.includes('meter')) return 'per_meter';
  if (l.includes('bundel')) return 'per_bundel';
  return '';
}

/** Label + optionele toelichting (bijv. weekendtijden op tweede regel). */
export function getProductPriceTierParts(label) {
  const key = normalizeProductPriceTierKey(label);
  const mapped = key && productCartItemPriceLabels[key];
  if (mapped && typeof mapped === 'object' && mapped.label) {
    return { label: mapped.label, detail: mapped.detail || '' };
  }
  const text =
    typeof mapped === 'string'
      ? mapped
      : String(label || '').replace(/:$/, '').trim();
  return { label: text, detail: '' };
}

/** Vervangt o.a. oude weekend-tekst uit PHP/cache door het actuele label. */
export function normalizeProductPriceTierLabel(label) {
  const { label: main, detail } = getProductPriceTierParts(label);
  return detail ? `${main} (${detail})` : main;
}

export const productCartItemAvailabilityMode = 'on_reserve';

/**
 * Centrale lijst van bekende ophaallocaties.
 * Wordt door <ProductCartItem> gebruikt als fallback wanneer de bootstrap
 * geen `pickupLocations` meelevert. De échte selectie per product komt uit
 * `oc_product_form_settings.pickup_location` (admin → tab Data).
 *
 * Toevoegen van een locatie: hier registreren én in
 *   - admin/model/catalog/product.php  -> getPickupLocationCatalog()
 *   - catalog/controller/product/product.php -> getVsbProductPickupLocationCatalog()
 */
export const productCartItemPickupLocations = [
  { id: 'culemborg', label: 'Culemborg' },
  { id: 'beesd', label: 'Beesd' }
];

export const productCartItemFeatureUsps = [
  { icon: 'shield', text: 'Diverse verzekeringsopties' },
  { icon: 'euro', text: 'Geen eigen risico' },
  { icon: 'clock', text: 'Snel te reserveren' },
  { icon: 'pin', text: 'Ophalen in Culemborg' }
];

export const productCartItemTrustCards = [
  {
    icon: 'calendar',
    title: 'Direct online reserveren',
    text: 'Binnen 2 minuten geregeld'
  },
  {
    icon: 'shield',
    title: 'Diverse verzekeringsopties',
    text: 'Kies bij het reserveren'
  },
  {
    icon: 'headset',
    title: 'Persoonlijk advies',
    text: 'Bel 0345 - 502615'
  }
];

export const productCartItemTheme = {
  cardBg: '#ffffff',
  cardBorder: '#e8ecf0',
  cardRadius: '12px',
  cardShadow: '0 4px 20px rgba(15, 23, 42, 0.1)',
  titleColor: '#0b3d91',
  priceAccent: '#3d9916',
  priceMuted: '#64748b',
  btnPrimaryBg: '#3d9916',
  btnPrimaryColor: '#ffffff',
  btnSecondaryBorder: '#0b3d91',
  btnSecondaryColor: '#0b3d91',
  trustBg: '#f8fafc',
  trustBorder: '#e8ecf0'
};
